/* eslint-disable no-undef */
var JSONWebKey = require( 'json-web-key' )

/**
 * Convert a BigInt back to a Uint8Array (big-endian).
 * Will remove leading 0
 */
function bigIntToUint8Array(bi) {
  // Convert to hex first
  let hex = bi.toString(16)
  if (hex.length % 2 === 1) {
    // pad to even length
    hex = '0' + hex
  }
  const len = hex.length / 2
  const u8 = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    u8[i] = parseInt(hex.substring(i * 2, i * 2 + 2), 16)
  }
  return u8
}

function buf2hex(buffer) { // buffer is an ArrayBuffer
  return [...new Uint8Array(buffer)]
      .map(x => x.toString(16).padStart(2, '0'))
      .join('');
}

async function sha256 (buffer) {
  const hash = await crypto.subtle.digest('SHA-256', buffer);
  return Array.from(new Uint8Array(hash))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

async function deriveKey(serverPublicKey, privateKey, namedCurve) {
  
  try {
    const sharedSecret  = await window.crypto.subtle.deriveBits({
      name: "ECDH",
      public: serverPublicKey,
      namedCurve
      },
      privateKey,
      null
    );

    const kdf = Buffer.from(buf2hex(sharedSecret)+"00000001",'hex');

    const encKey = await sha256(kdf)
    return encKey
  } catch (error) {
    console.log('deriveKey', error)
    throw error
  }
}

async function importPublicKey(jwk) {
  try {
    const PublicCryptoKey =  await window.crypto.subtle.importKey(
      "jwk",
      jwk,
    {
        name: "ECDH",
        namedCurve: jwk.crv
    },
      true,
    [],
    );

    return PublicCryptoKey
  } catch (error) {
    console.error(error)
    throw error
  }
}

async function exportKeys(publicKey) {
  try {
    const keys = await window.crypto.subtle.exportKey('jwk', publicKey)
    return keys
  } catch (error) {
    console.log('exportKeys',error)
    throw error
  }
}

async function generateKeys(namedCurve) {
  try {
    const newKeys = await window.crypto.subtle.generateKey( 
      {
        name: "ECDH",
        namedCurve: namedCurve,
      }, 
      true,
      ['deriveKey', 'deriveBits']
    );
    return newKeys
  } catch (error) {
    console.log('generateKeys', error)
    throw error
  }
}

async function encryptData(sad,iv,key) {
  try {
    const encrypted = await window.crypto.subtle.encrypt(
      {
        name: "AES-GCM",
        iv: iv, // 12-byte IV for AES-GCM
        tagLength: 128, // 128-bit tag (16 bytes)
      },
      key, // The imported AES key
      sad // The data to encrypt
    );

    return encrypted
  } catch (error) {
    console.log('erroor', error)
    throw new Error('Encryption erorr')
  }
}

async function encryptWithAESGCM(sad, encryptionKeyHex, ivHex) {
  
  const iv = Buffer.from(ivHex, 'hex')
  const encryptionKey = Buffer.from(encryptionKeyHex, 'hex')
  const sadData = Buffer.from(sad, 'ascii')
  
  // Ensure encryptionKey is a 32-byte key for AES-256
  const key = await crypto.subtle.importKey(
    "raw", 
    encryptionKey, 
    { name: "AES-GCM" }, 
    false, 
    ["encrypt"]
  );

  const authTag = new Uint8Array(16); // AES-GCM authentication tag
  const encrypted = await encryptData(sadData, iv, key)

  const encryptedArray = new Uint8Array(encrypted);
  authTag.set(encryptedArray.slice(encryptedArray.length - 16));

  const encryptedHex = buf2hex(encryptedArray.slice(0, encryptedArray.length - 16))
  const authTagHex = buf2hex(authTag)


  return {
    encrypted: encryptedHex, // Encrypted data in hex
    authTag: authTagHex // Auth tag in hex
  };
}

export async function encrypt(sad, publicX509KeyBase64, algver) {
  try {
    const serverPublicECKeyJWK = JSONWebKey.fromJSON(Buffer.from(publicX509KeyBase64, 'base64').toString())
  

    const serverPublicKey = await importPublicKey(serverPublicECKeyJWK.toJSON())

    

    const ephemeral = await generateKeys(serverPublicECKeyJWK.crv)

    const ephemeralEncKeyJWK = await exportKeys(ephemeral.publicKey)
        
    const encKey = await deriveKey(serverPublicKey, ephemeral.privateKey, serverPublicECKeyJWK.crv)

    const serverPublicECKeyX = Buffer.from(serverPublicECKeyJWK.x, 'base64').toString('hex')
    const serverPublicECKeyY = Buffer.from(serverPublicECKeyJWK.y, 'base64').toString('hex')


    const bigIntserverPublicECKeyX = BigInt("0x" + serverPublicECKeyX)
    const bigIntserverPublicECKeyY = BigInt("0x" + serverPublicECKeyY)
    const sum = (bigIntserverPublicECKeyX + bigIntserverPublicECKeyY)
    let ivRaw = bigIntToUint8Array(sum)

    const iv = new Uint8Array(12)
    iv.set(ivRaw.slice(0, 6), 0)
    iv.set(ivRaw.slice(ivRaw.length - 6), 6)
    const ivHex = Buffer.from(iv).toString('hex');
  
    const encryptedData = await encryptWithAESGCM(sad, encKey, ivHex)
    const ephemeralEncKeyPublicParamXBuff = Buffer.from(ephemeralEncKeyJWK.x, 'base64')
    const ephemeralEncKeyPublicParamYBuff = Buffer.from(ephemeralEncKeyJWK.y, 'base64')

    const ephemeralEncKeyPublicParams = "04" + ephemeralEncKeyPublicParamXBuff.toString('hex') + ephemeralEncKeyPublicParamYBuff.toString('hex')
  
    return {
      password: encryptedData.encrypted,
      tags: [encryptedData.authTag],
      ephemeralKeys:[ephemeralEncKeyPublicParams],
      algver
    }
  } catch (error) {
  
    console.log('error', error)
    throw new Error('Encryption error')
  }
  
}